import { ChangeDetectorRef, Directive, ElementRef, HostListener, Injector, Optional } from '@angular/core';
import { FormGroupDirective, NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ValueAccessor } from './value-accessor';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-checkbox, anj-toggle',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BooleanValueDirective,
            multi: true
        }
    ]
})
export class BooleanValueDirective extends ValueAccessor {
    constructor(@Optional() parentForm: NgForm,
                @Optional() parentFormGroup: FormGroupDirective,
                element: ElementRef,
                injector: Injector,
                changeRef: ChangeDetectorRef) {
        super(element, parentForm, parentFormGroup, injector, changeRef);
    }

    writeValue(value: any) {
        this.element.nativeElement.checked = this.lastValue = value == null ? false : value;
    }

    @HostListener('anjChange', ['$event.target.checked'])
    onAnjChange(value: any) {
        this.onChangeEvent(value);
    }
}
